export enum ErrorMessages {
  requiredField = "This is a required field",
  fileRequired = "A file is required",
  fileTooLarge = "File too large",
  unsupportedFileFormat = "Unsupported Format",
  dateShouldBeUnique = "Date should be unique",
  invalidEmail = "Enter a valid email",
  invalidExcelColumn = "Not a valid excel column",
  accountingNumberInvalid = "Accounting number is invalid",
  routingNumberInvalid = "Routing number is invalid",
}

export default ErrorMessages;
